<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2" color="grey lighten-5">
        <v-card class="my-3">
          <v-card-title>保守点検一覧
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search" color="indigo"
              single-line
              hide-details
              class="py-2 mx-2"
            ></v-text-field>
            <!-- ポップアップ表示 -->
            <div class="float-right">
              <!-- 保存された情報をダイアログに表示 -->
              <v-dialog v-model="checkDialog" width="500" @close="close">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark color="indigo" width="120" v-bind="attrs" v-on="on" @click="clickKuknBtn">
                    日付一括更新
                  </v-btn>
                </template>
                <v-card v-if="errorFlg">
                  <v-card-title class="headline indigo lighten-4" primary-title>日付一括更新</v-card-title>
                  <v-card-text>
                    <v-container>
                      <span style="white-space:pre-wrap;">行が選択されていません</span>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="indigo" text @click="checkDialog = false">戻る</v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-else>
                  <v-card-title class="headline indigo lighten-4" primary-title>日付一括更新</v-card-title>
                    <v-card-text>
                      <v-container>
                        <div justify="center" align="center" class="pa-2" v-if="validerrorFlg">
                          <span class="text-center red--text text--lighten-1">
                            {{MSG_E002_0007}}
                          </span>
                        </div>
                        <v-row>
                          {{infoMsg}}<br>
                          交換日付と時間を選択してください。<br>
                        </v-row>
                        <!-- ポップアップ内容 -->
                        <v-form ref="form">
                          <v-row>
                            <v-col>
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="formData.kukn_dt"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="formData.kukn_dt"
                                    :rules="mainRules"
                                    label="交換日付"
                                    readonly
                                    append-icon="event"
                                    v-on="on"
                                    required
                                  >
                                    <template v-slot:label>
                                      交換日付<strong class="red--text text--lighten-1">*</strong>
                                    </template>
                                  </v-text-field>
                                </template>
                                <v-date-picker v-model="formData.kukn_dt" no-title scrollable>
                                  <v-spacer />
                                  <v-btn text color="primary" @click="menu = false">キャンセル</v-btn>
                                  <v-btn text color="primary" @click="$refs.menu.save(formData.kukn_dt)">選択</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="formData.kukn_tm"
                                :rules="mainRules"
                                value="00:00"
                                label="交換時間"
                                type="time"
                                required
                              >
                              <template v-slot:label>
                                交換時間<strong class="red--text text--lighten-1">*</strong>
                              </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="indigo" text @click="checkDialog = false">キャンセル</v-btn>
                    <v-btn dark color="indigo" width="120" @click="submit()">更新</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <!-- ポップアップ表示 -->
            <v-btn width="120" class="mx-2" to='/HshTnknMstr/HshTnknMstrSnkTurk' color="indigo" dark>新規登録</v-btn>
            <v-btn width="120" color="indigo" dark @click="downloadCSV">ダウンロード</v-btn>
          </v-card-title>
          <v-data-table
            no-data-text="データがありません"
            no-results-text="検索結果が見つかりません"
            :loading="loading"
            loading-text="読み込み中です"
            :headers="headers"
            :items="listItems"
            :search="search"
            :height="listHeight"
            :footer-props="{
              'items-per-page-options': [10,30,50,-1]
            }"
            fixed-header
          >
            <template v-slot:item.actions="{ item }">
              <v-row>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" icon color="indigo" @click="showDetail(item.id)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>詳細</span>
                </v-tooltip>
                <template>
                  <hsh-tnkn-dialog :kki_nm='item.kki_nm' :bhn_nm='item.bhn_nm' :hsh_cd='item.id' />
                </template>
                <template>
                  <v-checkbox color="indigo" class="checkbox" :id='item.id' :value='item.id' v-model="selected"/>
                </template>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios.js'

import HshTnknDialog from '@/components/templates/HshTnknMstr/HshTnknMstrRrk'

export default {
  components: {
    MstrHedr,
    HshTnknDialog
  },
  data () {
    return {
      windowSize: {
        x: 0,
        y: 0
      },
      listHeight: 600,
      userInfo: false,
      listItems: [],
      loading: true,
      rowSelected: 50,
      totalList: 0,
      searchWord: '',
      search: '',
      headers: [
        { text: '', value: 'actions', sortable: false },
        {text: '機械名', value: 'kki_nm', align: 'start'},
        {text: '部分名', value: 'bbn_nm'},
        {text: '部品名', value: 'bhn_nm'},
        {text: '部品情報', value: 'bhn_info'},
        {text: '個数', value: 'bhn_num'},
        {text: '集計方法', value: 'sum_type_name'},
        {text: '交換警告値', value: 'kukn_kikk_val'},
        {text: '交換推奨値', value: 'kukn_sish_val'},
        {text: '最新交換日', value: 'kukn_dt'}
      ],
      selected: [],
      errorFlg: false,
      dialogOpenCnt: 0,
      validerrorFlg: false,
      checkDialog: false,
      formData: {
        kukn_dt: '',
        kukn_tm: '00:00'
      },
      menu: false,
      mainRules: [
        v => !!v || '入力は必須です'
      ],
      kukndtIsValid: true,
      kukntmIsValid: true,
      MSG_E002_0007: MsgList.MSG_E002_0007,
      infoMsg: ''
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // インスタンス生成時にセッションにある検索キーワードを破棄する
          myAxios.delete('api/hshtnkn_mstr/hshtnkn_master_kanri').then(res => {
            //  保守点検情報一覧をDBから持ってくる
            this.getMemberList()
          })
        }
      })
    })
  },
  watch: {
  },
  // 更新時に毎回呼び出される
  mounted () {
    this.onResize()
    this.changeListSize()
  },
  methods: {
    // 画面サイズ取得
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    // 一覧表示サイズを変更
    changeListSize () {
      this.listHeight = this.windowSize.y * 0.7
    },
    // 保守点検一覧を取得する
    getMemberList () {
      myAxios.get('api/hshtnkn_mstr/hshtnkn_master_kanri').then(res => {
        // 0が帰ってきたらリストアイテムは空にする
        if (res.data === 0) {
          this.listItems = []
          this.loading = false
        } else {
          this.totalList = res.data[0]
          this.listItems = res.data[1]
          this.loading = false
        }
      // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        console.log(err)
        this.listItems = []
        this.loading = false
      })
    },
    // 保守点検一覧をCSV形式でDLする
    downloadCSV () {
      // axiosでダウンロードデータを取得する
      myAxios.get('api/hshtnkn_mstr/hshtnkn_master_download', { search: this.search }).then(res => {
        let csv = '\ufeff' + '機械名,部分名,部品名,部品情報,個数,集計方法,交換警告値,交換推奨値,最新交換日\n'
        // 取得したレコードを行ごとに整形する
        res.data.forEach(el => {
          let line = el['kki_nm'] + ',' + el['bbn_nm'] + ',' + el['bhn_nm'] + ',' + el['bhn_info'] + ',' + el['bhn_num'] + ',' + el['sum_type_name'] + ',' + el['kukn_kikk_val'] + ',' + el['kukn_sish_val'] + ',' + el['kukn_dt'] + '\n'
          csv += line
        })
        let blob = new Blob([csv], { type: 'text/csv' })
        let link = document.createElement('a')
        const date = new Date()
        link.href = window.URL.createObjectURL(blob)
        // 月を0埋めする
        var mon = String(date.getMonth() + 1)
        if (mon.length === 1) { mon = '0' + mon }
        var day = String(date.getDate())
        if (day.length === 1) { day = '0' + day }
        link.download = 'list_maintenance_' + date.getFullYear() + mon + day + '.csv'
        link.click()
      })
    },
    showDetail (id) {
      this.$store.dispatch('appSetting/selectItem', id)
      this.$router.push({path: '/HshTnknMstr/HshTnknMstrJuhuShusi'})
    },
    // 交換日付のボタン押下時の処理
    clickKuknBtn () {
      // チェックが1つもされていない場合はエラーMSG表示
      if (this.selected.length === 0) {
        this.errorFlg = true
        // エラー表示の場合は初期化
        this.dialogOpenCnt = 0
      } else {
        this.errorFlg = false
        // 件数表示のメッセージを作成
        this.infoMsg = String(this.selected.length) + '件チェックされています。'
        // 入力値を初期化
        this.formData.kukn_dt = ''
        this.formData.kukn_tm = '00:00'
        // 入力フォーム表示が2回目以降の場合はバリデーションリセット
        if (this.dialogOpenCnt > 0) {
          // バリデーションリセット
          this.$refs.form.resetValidation()
        }
        this.dialogOpenCnt++
        // 上部のメッセージを非表示
        this.validerrorFlg = false
      }
    },
    // 交換日付入力チェック
    checkKukndt () {
      if (!this.formData.kukn_dt) {
        this.kukndtIsValid = false
      } else {
        this.kukndtIsValid = true
      }
    },
    // 交換時間入力チェック
    checkKukntm () {
      // deleteされた場合「--」になるためチェック
      if (this.formData.kukn_tm === '') {
        this.kukntmIsValid = false
      } else {
        this.kukntmIsValid = true
      }
    },
    // 入力データをサーバーに送信・登録処理を行う
    submit () {
      // 入力チェック
      this.checkKukndt()
      this.checkKukntm()
      this.$refs.form.validate()

      if (this.kukndtIsValid && this.kukntmIsValid) {
        this.validerrorFlg = false
        this.checkDialog = false
        // サーバー処理
        myAxios.post('/api/hshtnkn_mstr/hshtnkn_master_kukndt_update', {kukn_dt: this.formData.kukn_dt, kukn_tm: this.formData.kukn_tm, hsh_tnkn_cd_list: this.selected}).then(res => {
          const status = res.data.status
          const result = res.data.result

          if (status && result) {
            this.$router.go({path: '/HshTnknMstr/HshTnknMstrKnr', force: true})
            // faviconが消える対策
            this.$router.push('/initial')
          } else {
            alert(MsgList.MSG_FORM_SUBMIT_ERROR)
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          // アラート表示
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        })
      } else {
        // ダイアログ上部にエラーメッセージ表示
        this.validerrorFlg = true
      }
    }
  },
  computed: {
  }
}

</script>

<style scoped>
.checkbox {
  width: 40px;
  height: 40px;
  padding-left: 4px;
  margin-top: 3px;
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/HshTnknMstr/HshTnknMstrKnr.vue